<div class="h-screen w-screen flex flex-col bg-slate-100 dark:bg-stone-900">
    <div class="flex justify-center grow items-center w-full p-6 md:p-0">
        <div class="w-full flex justify-center max-w-5xl shadow-2xl bg-white dark:bg-black p-4 gap-4 rounded-3xl">
            <!-- Form -->
            <div class="w-full md:w-5/12 p-6 flex flex-col justify-center items-center relative">
                <!-- Logo -->
                <span class="w-fit py-1 px-2 rounded-md bg-grips-blue dark:bg-transparent block absolute top-4 left-4">
                    <img class="w-16 h-auto" src="grips-logo.png" alt="" sizes="" srcset="">
                </span>
                <form class="w-full block pt-20 md:pt-0" [formGroup]="loginForm">
                    <h1 class="text-slate-900 dark:text-slate-200 text-3xl font-bold text-center"> ¡Bienvenido a Grips Admin!</h1>
                    <!--Input Name-->
                    <mat-form-field class="w-full py-4" appearance="outline">
                        <mat-label>Usuario</mat-label>
                        <input formControlName="username" matInput placeholder="Ejem.Daniel" required
                            autocomplete="on" />
                        @if (username?.invalid && (username?.dirty || username?.touched)) {
                        <mat-error>
                            @if (username?.hasError('required')) {
                            <span class="text-xs">Campo requerido </span>
                            }
                            @if (username?.hasError('minlength')) {
                            <span class="text-xs"> Debe contener mínimo
                                {{username?.getError('minlength').requiredLength}}
                                caracteres, tienen {{username?.getError('minlength').actualLength}} </span>
                            }
                            @if (username?.hasError('maxlength')) {
                            <span class="text-xs"> Debe contener máximo
                                {{username?.getError('maxlength').requiredLength}}
                                caracteres, tienen {{username?.getError('maxlength').actualLength}} </span>
                            }
                            @if (username?.hasError('notMatch')) {
                            <span class="text-xs"> El usuario o la contraseña son incorrectos.</span>
                            }
                        </mat-error>
                        }
                    </mat-form-field>
                    <!-- Input Password -->
                    <mat-form-field class="w-full pb-4" appearance="outline">
                        <mat-label>Contraseña</mat-label>
                        <input formControlName="password" [type]="hide ? 'password' : 'text'" matInput
                            placeholder="Ejem. 123-25" required autocomplete="on" />
                        <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hide">
                            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                        @if (password?.invalid && (password?.dirty || password?.touched)) {
                        <mat-error>
                            @if (password?.hasError('required')) {
                            <span class="text-xs">Campo requerido </span>
                            }
                            @if (password?.hasError('minlength')) {
                            <span class="text-xs"> Debe contener mínimo
                                {{password?.getError('minlength').requiredLength}}
                                caracteres, tienen {{password?.getError('minlength').actualLength}} </span>
                            }
                            @if (password?.hasError('maxlength')) {
                            <span class="text-xs"> Debe contener máximo
                                {{password?.getError('maxlength').requiredLength}}
                                caracteres, tienen {{password?.getError('maxlength').actualLength}} </span>
                            }
                        </mat-error>
                        }
                    </mat-form-field>
                    <button mat-flat-button [color]="'secondary'" class="w-full" [disabled]="!loginForm.valid || cargando"
                        (click)="login()">
                        @if (cargando) {
                        <mat-spinner class="text-white!" [diameter]="20"></mat-spinner>
                        } @else {
                        Iniciar Sesión
                        }
                    </button>
                    <a href=""
                        class="text-center font-normal text-slate-900 text-xs hover:underline mt-6 block dark:text-slate-200">¿Olvidaste la
                        contraseña?</a>
                </form>
            </div>
            <!-- Image -->
            <div class="hidden md:block md:w-7/12 min-h-[70vh] relative overflow-hidden rounded-lg ">
                <div
                    class="absolute left-0 right-0 top-0 bottom-0 m-auto  bg-linear-to-t from-grips-blue/90 to-grips-blue/20  dark:from-grips-cyan/25 dark:to-grips-cyan/0  z-10">
                </div>
                <img class="w-full h-full object-cover object-right absolute left-0 right-0 top-0 bottom-0 m-auto"
                    src="imagen-operador.jpg" alt="" srcset="">
            </div>
        </div>
    </div>
</div>